<template>
  <div class="tab-content faq-content-page">
    <div class="faq-page">
      <main class="main-content">
        <section class="faq-section">
          <div class="container">
            <div class="header-area">
              <h1>{{ t('faq.title') }}</h1>
              <p class="subtitle">FREQUENTLY ASKED QUESTIONS</p>
              
              <div class="search-box">
                <i class="el-icon-search search-icon"></i>
                <input 
                  v-model="faqSearchQuery" 
                  type="text" 
                  :placeholder="t('faq.searchPlaceholder')"
                />
              </div>
            </div>

            <div class="faq-content-list">
              <div 
                v-for="(item, index) in filteredFaqList" 
                :key="index"
                class="faq-card"
                :class="{ 'is-active': activeFaqIndex === index }"
                @click="toggleFaq(index)"
              >
                <div class="faq-question">
                  <div class="q-left">
                    <span class="q-badge">Q{{ index + 1 }}</span>
                    <h2>{{ item.question }}</h2>
                  </div>
                  <div class="toggle-icon">
                    <span></span>
                    <span></span>
                  </div>
                </div>

                <transition name="slide-fade">
                  <div v-show="activeFaqIndex === index" class="faq-answer">
                    <div class="answer-inner">
                      <span class="a-badge">A</span>
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </transition>
              </div>

              <div v-if="filteredFaqList.length === 0" class="no-result">
                <p>🔍 {{ t('faq.noResult') }}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import i18nData from '@/i18n/locales.js'

export default {
  name: 'FaqTab',
  props: {
    lang: { type: String, default: 'zh' }
  },
  data() {
    return {
      faqSearchQuery: '',
      activeFaqIndex: 0,
      i18n: i18nData
    }
  },
  computed: {
    faqList() {
      const list = this.t('faq.list')
      return Array.isArray(list) ? list : []
    },
    filteredFaqList() {
      if (!this.faqSearchQuery) return this.faqList
      const query = this.faqSearchQuery.toLowerCase()
      return this.faqList.filter(item => 
        (item.question && item.question.toLowerCase().includes(query)) || 
        (item.answer && item.answer.toLowerCase().includes(query))
      )
    }
  },
  methods: {
    t(key) {
      const keys = key.split('.')
      let val = this.i18n[this.lang]
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return key
        }
      }
      return val
    },
    toggleFaq(index) {
      this.activeFaqIndex = this.activeFaqIndex === index ? -1 : index
    }
  }
}
</script>

<style scoped>
@import '../assets/styles/faq.css';
</style>